<template>
  <div class="answer" :class="classes">
    <div class="answer__content">
      <div v-html="answer.text" />
    </div>
    <svg class="answer__hand" fill="#D3D3D3" viewBox="0 0 48 48">
      <path
        d="M7.6 14.6a.78.78 0 01-.78-.77V2.35a2.35 2.35 0 014.7 0v10.43a.78.78 0 01-1.57 0V2.35a.78.78 0 00-1.57 0v11.48c0 .43-.35.78-.78.78z"
      />
      <path
        d="M13.86 13.57a.78.78 0 01-.78-.79V8.61a.78.78 0 00-1.57 0 .78.78 0 01-1.56 0 2.35 2.35 0 014.7 0v4.17c0 .43-.36.79-.8.79z"
      />
      <path
        d="M16.99 13.57a.78.78 0 01-.78-.79V9.65a.78.78 0 00-1.57 0 .78.78 0 01-1.56 0 2.35 2.35 0 014.7 0v3.13c0 .43-.36.79-.8.79z"
      />
      <path
        d="M15.95 24h-5.78c-1.26 0-2.7-.73-3.93-2a11.42 11.42 0 01-3.07-8.2 3.7 3.7 0 013.65-3.63h.78a.78.78 0 010 1.57h-.78a2.1 2.1 0 00-2.09 2.08 9.76 9.76 0 002.62 7.1c.94.95 2 1.51 2.82 1.51h5.78a3.4 3.4 0 003.39-3.39V10.7a.78.78 0 00-1.57 0 .78.78 0 01-1.56 0 2.35 2.35 0 014.7 0v8.34A4.96 4.96 0 0115.94 24z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    answer: {
      type: Object,
      required: true,
    },
    active: {
      type: [Object, Boolean],
    },
  },
  computed: {
    classes() {
      return [
        ...(this.answer?.mod
          ? this.answer?.mod.map((m) => `answer--${m}`)
          : []),
        {
          "answer--active": this.active && this.active.id === this.answer.id,
          "answer--inactive": this.active && this.active.id !== this.answer.id,
        },
      ];
    },
  },
  mounted() {
    this.$emit("init", this.answer.id);
  },
};
</script>

<style lang="scss" scoped>
.answer {
  color: #000;
  padding: 1.5rem;
  font-size: 1.125rem;
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 20%;
  font-weight: 300;
  margin: 0 0 0 1rem;
  cursor: pointer;
  align-items: center;
  position: relative;
  overflow: hidden;
  max-width: 33%;

  @include media-breakpoint-down(xl) {
    font-size: 1rem;
    padding: 1rem;
  }

  @include media-breakpoint-down(lg) {
    font-size: 0.75rem;
    padding: 0.75rem;
  }

  @include media-breakpoint-down(lg) {
    font-size: 0.625rem;
    padding: 0.625rem;
  }

  &--active {
    &:before {
      transform: scale(1, 1) !important;
    }
  }
  &:hover {
    &:before {
      transform: scale(1, 1);
    }
  }

  &--centered {
    justify-content: center;
    text-align: center;
  }
  &--big {
    font-size: 2.25rem;
  }

  &--inactive {
    &:before {
      display: none;
    }
  }

  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffd100;
    height: 10px;
    transform: scale(1, 0);
    transition: all 0.2s;
  }

  &:first-child {
    margin-left: 0;
  }
  &__hand {
    position: absolute;
    width: 1.5rem;
    height: 1.5rem;
    right: 1rem;
    bottom: 1rem;

    @include media-breakpoint-down(lg) {
      width: 1rem;
      height: 1rem;
      right: 0.5rem;
      bottom: 0.5rem;
    }
  }
}
</style>
